import React from "react";
import ReactDom from "react-dom";
import { AppContainer } from 'react-hot-loader'
import { TranslationProvider } from 'giro-react-toolkit/source/Translation';

// Cette variable sert pour le hot module replacement afin d'éviter que webpack dev server
// utilise le domain du site web (IIS) pour ses communications avec websocket. On force ainsi
// à utiliser le domain de webpack dev server.
__webpack_public_path__ = "http://localhost:8181/"; // eslint-disable-line no-undef

// main app
import App from "./App";

const translations = JSON.parse(document.getElementById('reachMapTranslations').text);

const render = Component => {
   /* AppContainer is necessary for react-hot-loader */
   ReactDom.render(
      <AppContainer>
         <TranslationProvider defaultCulture={ document.documentElement.lang } translations={ translations }>
            <Component />
         </TranslationProvider>
      </AppContainer>,
      document.getElementById('root')
   );
}

render(App);

/* for Webpack hot reload */
if (module.hot) {
   module.hot.accept('./App',
      () => {
         render(App);
      });
}
